export default __webpack_public_path__ + "static/media/vegshelf-blog-grocery-shops-need-more-vegan-products.0bd85724.png";